import React from 'react';
import { IconProps } from '.';

const SvgSearchAi = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M10.898 3.735a7.898 7.898 0 1 0 7.896 7.898h1.5c0 2.324-.847 4.45-2.245 6.09l4.496 4.497-1.06 1.06-4.497-4.496a9.357 9.357 0 0 1-6.09 2.245 9.397 9.397 0 1 1 0-18.794v1.5Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M16.451 1c.314 0 .595.195.704.49l.319.86c.441 1.194.596 1.568.865 1.837.268.268.642.423 1.835.865l.861.318a.75.75 0 0 1 0 1.407l-.861.319c-1.193.441-1.567.596-1.835.865-.269.268-.424.642-.865 1.835l-.319.861a.752.752 0 0 1-1.407 0l-.318-.861c-.442-1.193-.597-1.567-.865-1.835-.27-.269-.643-.424-1.836-.865l-.862-.319a.751.751 0 0 1 0-1.407l.861-.318c1.194-.442 1.568-.597 1.837-.865.268-.27.423-.643.865-1.836l.318-.862.049-.105A.75.75 0 0 1 16.45 1Zm0 2.88c-.23.56-.465 1.007-.826 1.367-.36.36-.807.596-1.366.826.56.23 1.005.467 1.366.827.36.36.596.806.826 1.365.23-.56.467-1.004.827-1.365.36-.36.806-.597 1.366-.827-.56-.23-1.005-.466-1.366-.826-.36-.36-.597-.806-.827-1.366Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgSearchAi;
